import { trans } from '@spotahome/soyuz/client';

import LandingSellingPointsSection from '@spotahome/landings-common/src/components/LandingSellingPointsSection';

import HeartLockIcon from '../Icons/HeartLockIcon';

import EnvelopeIcon from './Icons/EnvelopeIcon';
import ClockIcon from './Icons/ClockIcon';
import KnittedIcon from './Icons/KnittedIcon';

const POINTS = [
  {
    titleKey: 'how_it_works.guarantees.block1.title',
    textKey: 'how_it_works.guarantees.block1.text',
    renderImage: className => <EnvelopeIcon className={className} />
  },
  {
    titleKey: 'how_it_works.guarantees.block2.title',
    textKey: 'how_it_works.guarantees.block2.text',
    renderImage: className => <ClockIcon className={className} />
  },
  {
    titleKey: 'how_it_works.guarantees.block3.title',
    textKey: 'how_it_works.guarantees.block3.text',
    renderImage: className => <KnittedIcon className={className} />
  }
];

const SellingPoints = () => {
  return (
    <LandingSellingPointsSection
      title={trans('tenant_guarantees.selling_points.title')}
      description={trans('tenant_guarantees.selling_points.description')}
      subtitle={trans('how_it_works.spotahome.guarantee')}
      renderSubtitleIcon={() => <HeartLockIcon />}
      points={POINTS}
      color="secondary-pink-light"
    />
  );
};

export default SellingPoints;
